var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"newsletter-type-subscriber-items"},_vm._l((_vm.subscriptions),function(subscription){return _c('div',{staticClass:"subscribers"},[_c('router-link',{class:subscription.status,attrs:{"to":{
      name: 'newsletter_type_subscriber',
      params: { newsletterTypeSubscriberId: subscription.id }
    }}},[_vm._v("\n      "+_vm._s(subscription.subscriber_email)+"\n    ")])],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68280c3a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewsletterTypeSubscriberItems.vue
// module id = 1212
// module chunks = 1